import {
  Box,
  Button,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  Popper,
  styled,
  SxProps,
  Theme,
  Typography,
} from '@mui/material';
import palette from 'src/theme/palette';

export const FiltersWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '15px',
  alignItems: 'center',
  flexWrap: 'wrap',
  minWidth: 0, // Importante per prevenire overflow
  maxWidth: '100%', // Aggiunto per prevenire overflow
  boxSizing: 'border-box', // Aggiunto per calcolo corretto delle dimensioni

  [theme.breakpoints.down('md')]: {
    gap: '10px',
  },

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: '10px',
    alignItems: 'stretch',

    ' .filters': {
      width: '100%',
      minWidth: 0,
      maxWidth: '100%',
      overflow: 'hidden',
    },
  },

  [theme.breakpoints.down('xs')]: {
    gap: '8px',
  },
}));

export const DashboardTableDrawer = styled(Drawer)(({ theme }) => ({
  zIndex: 900,

  ' .MuiPaper-root': {
    width: 'calc(100vw - 240px)',
    zIndex: 90,
    marginLeft: 'auto',
  },

  [theme.breakpoints.down('md')]: {
    ' .MuiPaper-root': {
      width: 'calc(100vw - 220px)',
    },
  },

  [theme.breakpoints.down('sm')]: {
    ' .MuiPaper-root': {
      height: 'calc(100% - 60px)',
      top: '60px',
      marginLeft: 0,
      width: '100%',
    },
  },
}));

export const MainButtonGroupWrapper = styled(Box)(({ theme }) => ({
  justifyContent: 'space-between',
  display: 'flex',
  gap: '20px',
  borderTop: `1px solid ${theme.palette.grey[100]}`,
  padding: '20px 0', // Rimosso padding laterale per allineare con il container padre
  alignItems: 'center',
  marginTop: 'auto',
  marginLeft: theme.spacing(3), // Allinea con il padding del container padre
  marginRight: theme.spacing(3), // Allinea con il padding del container padre

  [theme.breakpoints.down('md')]: {
    marginLeft: theme.spacing(2), // Allinea con il padding del container padre su md
    marginRight: theme.spacing(2), // Allinea con il padding del container padre su md
  },

  [theme.breakpoints.down('sm')]: {
    marginLeft: theme.spacing(1), // Allinea con il padding del container padre su sm
    marginRight: theme.spacing(1), // Allinea con il padding del container padre su sm
  },

  [theme.breakpoints.down('xs')]: {
    marginLeft: theme.spacing(0.5), // Allinea con il padding del container padre su xs
    marginRight: theme.spacing(0.5), // Allinea con il padding del container padre su xs
  },
}));

export const DeleteButton = styled(Button)(({ theme }) => ({
  padding: '14px 23px',
  borderRadius: '6px',
  color: theme.palette.primary.contrastText,
  border: `1px solid ${theme.palette.primary.main}`,

  '&:hover': {
    border: `1px solid ${theme.palette.primary.main}`,
  },
}));

export const DownloadButton = styled(Button)(({ theme }) => ({
  padding: '15.5px',
  width: '240px',
  borderRadius: '6px',
  fontSize: '16px',
  fontWeight: 700,
  lineHeight: '21px',
  color: theme.palette.primary.contrastText,
  backgroundColor: theme.palette.primary.main,

  '&:disabled': {
    backgroundColor: theme.palette.action.disabled,
    color: theme.palette.common.black,
  },

  '&:hover': {
    backgroundColor: theme.palette.primary.main,
  },
}));

export const MetricsCard = styled(Box)(({ theme }) => ({
  gridArea: 'metrics',
  border: '1px solid rgba(221, 221, 234, 1)',
  padding: '13px 20px 20px',
  borderRadius: '6px',
  height: 'fit-content',
  minWidth: '200px',

  [theme.breakpoints.down('sm')]: {
    border: 'none',
    padding: '20px',
    width: 'auto',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
}));

export const CalendarWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '15px',
  minWidth: 0, // Importante per prevenire overflow
  maxWidth: '100%', // Aggiunto per prevenire overflow
  boxSizing: 'border-box', // Aggiunto per calcolo corretto delle dimensioni
  flexShrink: 1, // Permette al wrapper di restringersi se necessario
  marginRight: '0px', // Rimosso marginRight fisso per allineare con il nuovo padding del HeaderBlock

  [theme.breakpoints.down('md')]: {
    gap: '10px',
    marginRight: '0px', // Rimosso marginRight fisso per allineare con il nuovo padding del HeaderBlock su md
  },

  [theme.breakpoints.down('sm')]: {
    gap: '8px',
    width: '100%',
    justifyContent: 'center',
    marginRight: '0px', // Rimosso marginRight fisso per allineare con il nuovo padding del HeaderBlock su sm
  },

  [theme.breakpoints.down('xs')]: {
    gap: '6px',
    flexDirection: 'column',
    alignItems: 'stretch',
    marginRight: '0px', // Rimosso marginRight fisso per allineare con il nuovo padding del HeaderBlock su xs
  },
}));

export const ParametrsWrapper = styled(Box)(() => ({
  display: 'flex',
  gap: '15px',
  padding: '0 20px 20px 20px',
  flexDirection: 'column',
  overflow: 'auto',

  ' .MuiInputBase-root': {
    width: '100%',
  },
}));

export const CustomDrawer = styled(Drawer)(() => ({
  zIndex: 1000,

  ' .MuiPaper-root': {
    width: '100%',
    height: 'calc(100% - 60px)',
    top: '60px',
    zIndex: 100,
  },
}));

export const MetricsDrawer = styled(Drawer)(() => ({
  zIndex: 1010,

  ' .MuiPaper-root': {
    width: '100%',
    height: 'calc(100% - 60px)',
    top: '60px',
    zIndex: 110,
  },
}));

export const BackButton = styled(Button)(({ theme }) => ({
  padding: '15.5px',
  width: '100%',
  borderRadius: '6px',
  fontSize: '16px',
  fontWeight: 700,
  lineHeight: '21px',
  color: theme.palette.primary.contrastText,
  border: `1px solid ${theme.palette.primary.main}`,

  '&:hover': {
    border: `1px solid ${theme.palette.primary.main}`,
  },
}));

export const SaveButton = styled(Button)(({ theme }) => ({
  padding: '15.5px',
  width: '100%',
  borderRadius: '6px',
  fontSize: '16px',
  fontWeight: 700,
  lineHeight: '21px',
  color: theme.palette.primary.contrastText,
  backgroundColor: theme.palette.primary.main,

  '&:hover': {
    backgroundColor: theme.palette.primary.main,
  },
}));

export const ParametrsButton = styled(Button)(({ theme }) => ({
  padding: '6.5px 10px',
  alignItems: 'center',
  border: `1px solid ${theme.palette.grey[100]}`,
  borderRadius: '6px',
  color: theme.palette.primary.contrastText,
  fontWeight: 600,

  '&:hover': {
    border: `1px solid ${theme.palette.grey[100]}`,
  },
}));

export const TableWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '0 24px 0 24px',
  gap: '10px',
  overflowY: 'auto',
  overflowX: 'hidden',

  [theme.breakpoints.down('sm')]: {
    padding: '10px 24px 10px 20px',
  },
}));

export const Wrapper = styled(Box)(({ theme }) => ({
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  minWidth: 0,
  gap: '10px',
  overflow: 'visible', // Aggiunto per evitare tagli
  boxSizing: 'border-box', // Aggiunto per calcolo corretto delle dimensioni

  [theme.breakpoints.down('md')]: {
    width: '100%',
  },

  [theme.breakpoints.down('sm')]: {
    width: '100%',
    height: '100%',
  },
}));

export const MetricWrapper = styled(Box)(() => ({
  display: 'flex',
  cursor: 'pointer',
  alignItems: 'center',
}));

export const MetricName = styled(Typography)(() => ({
  fontSize: '16px',
  lineHeight: '20.8px',
  cursor: 'pointer',

  '&:hover': {
    color: 'rgba(15, 182, 120, 1)',
  },
}));

export const metricNameStyles = (isDisabled: boolean): SxProps<Theme> => ({
  color: isDisabled ? palette.action.disabled : undefined,

  '&:hover': {
    color: isDisabled ? palette.action.disabled : 'rgba(15, 182, 120, 1)',
  },
});

export const splitNameStyles = (isDisabled: boolean): SxProps<Theme> => ({
  color: isDisabled ? palette.action.disabled : undefined,

  '&:hover': {
    color: isDisabled ? palette.action.disabled : undefined,
  },
});

export const SubGroupName = styled(Typography)(() => ({
  fontWeight: '500',
  color: 'rgba(1, 128, 148, 1)',
  textTransform: 'uppercase',
}));

export const InnerContainer = styled(Box)(() => ({
  display: 'flex',
  gap: '10px',
  flexDirection: 'column',
  marginLeft: '8px',
}));

export const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '10px',
  flexDirection: 'column',
  paddingBottom: '15px',
  maxHeight: '455px',
  overflow: 'auto',

  // temporary (before "total sales")
  '&>div:first-of-type': {
    marginTop: '10px',
  },

  [theme.breakpoints.down('sm')]: {
    maxHeight: '270px',
  },
}));

export const datePickerPopperStyles: SxProps<Theme> = {
  ' .MuiPickersPopper-paper': {
    marginTop: '10px',
  },

  ' .MuiPickersArrowSwitcher-button': {
    padding: 0,
  },

  ' .MuiPickersDay-today:not(.Mui-selected)': {
    backgroundColor: palette.grey[100],
    border: 'none',
  },

  ' .MuiButtonBase-root:focus.Mui-selected': {
    backgroundColor: palette.primary.main,
  },
  ' .MuiPickersYear-yearButton.Mui-selected:focus': {
    backgroundColor: palette.primary.main,
  },
};

export const checkboxStyles: SxProps<Theme> = {
  marginRight: '8px',

  ' svg': {
    minWidth: '24px',
    minHeight: '24px',
  },
};

export const splitsInputStyles: SxProps<Theme> = {
  padding: '0 7px',
  width: '200px',
  minWidth: 0, // Importante per prevenire overflow
  maxWidth: '100%', // Aggiunto per prevenire overflow
  boxSizing: 'border-box', // Aggiunto per calcolo corretto delle dimensioni

  ' input': {
    padding: '5px 5px 5px 0',
    fontSize: '16px',
    fontWeight: 600,
    minWidth: 0,
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  ' fieldset': { top: 0, borderColor: palette.primary.main },
};

export const calendarHeaderStyles: SxProps<Theme> = {
  position: 'relative',
  paddingLeft: '12px',
  justifyContent: 'center',

  ' .MuiPickersArrowSwitcher-root': {
    justifyContent: 'space-between',
    position: 'absolute',
    width: '93%',
    left: '12px',
  },

  ' .MuiPickersCalendarHeader-labelContainer': {
    marginRight: 0,
    zIndex: 300,

    ' svg,button': {
      display: 'none',
    },
  },
};

export const popoverStyles = (isMobile: boolean): SxProps<Theme> => ({
  marginTop: '5px !important',
  borderRadius: '6px',
  boxShadow: `0px 24px 48px 0px rgba(0, 0, 0, 0.14), 0px 0px 4px 0px rgba(0, 0, 0, 0.2)`,
  width: isMobile ? 'calc(100vw - 55px)' : '310px',
  padding: '0px 5px 0 10px',
});

export const CustomPopper = styled(Popper)(({ theme }) => ({
  marginTop: '5px !important',
  borderRadius: '6px',
  padding: '15px 3px 15px 5px',
  boxShadow: `0px 24px 48px 0px rgba(0, 0, 0, 0.14), 0px 0px 4px 0px rgba(0, 0, 0, 0.2)`,
  backgroundColor: palette.common.white,
  zIndex: 1100,

  [theme.breakpoints.down('sm')]: {
    width: 'calc(100vw - 48px)',
    maxHeight: '310px',
  },
}));

export const HeaderBlock = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2.5, 3, 1.5), // top, right/left, bottom  (20px, 24px, 12px)
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '40px',
  borderBottom: `1px solid ${theme.palette.grey[100]}`,
  width: '100%',
  minWidth: 0,
  maxWidth: '100%',
  boxSizing: 'border-box',

  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2.5, 2, 1.5), // <-- tieni padding orizzontale (16px), niente margin
    gap: '20px',
  },

  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1.875, 1, 1.25), // 15px 8px 10px
    gap: '15px',
    flexDirection: 'column',
    alignItems: 'stretch',
  },

  [theme.breakpoints.down('xs')]: {
    padding: theme.spacing(1.25, 0.5, 1), // 10px 4px 8px
    gap: '10px',
  },
}));

export const FiltersContainer = styled(Box)(({ theme }) => ({
  // prima era: padding: '5px 0', marginLeft/Right: ...
  padding: theme.spacing(0.625, 3), // 5px verticali, 24px orizzontali
  display: 'flex',
  alignItems: 'flex-start', // Cambiato da 'center' a 'flex-start' per evitare tagli
  width: '100%',
  boxSizing: 'border-box',
  minWidth: 0,
  maxWidth: '100%',
  overflow: 'visible', // Cambiato da 'hidden' a 'visible' per evitare tagli
  flexWrap: 'wrap', // Aggiunto per permettere il wrap quando necessario
  gap: '8px', // Aggiunto gap per separare gli elementi

  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(0.625, 2),
    gap: '6px',
  },

  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1.25, 1), // 10px 8px
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: '10px',
  },

  [theme.breakpoints.down('xs')]: {
    padding: theme.spacing(1, 0.5), // 8px 4px
    gap: '8px',
  },
}));

export const inputStyles: SxProps<Theme> = {
  ' .MuiInputAdornment-root': {
    marginLeft: '0px',
  },

  ' input': {
    padding: '6px 5px 7px 10px',
    width: '92px',
    fontSize: '14px',
    minWidth: 0, // Importante per prevenire overflow
    maxWidth: '100%', // Aggiunto per prevenire overflow
    boxSizing: 'border-box', // Aggiunto per calcolo corretto delle dimensioni
    textOverflow: 'ellipsis', // Aggiunge ... se il testo è troppo lungo
    overflow: 'hidden', // Nasconde il testo che va oltre
    whiteSpace: 'nowrap', // Impedisce il wrap del testo
  },

  ' fieldset': { top: 0 },
  ' button': { padding: 0 },
};

export const responsiveInputStyles = (theme: Theme): SxProps<Theme> => ({
  ' .MuiInputAdornment-root': {
    marginLeft: '0px',
  },

  ' input': {
    padding: '6px 5px 7px 10px',
    width: '105px', // Larghezza ridotta per eliminare spazio vuoto dopo l'anno
    fontSize: '14px',
    minWidth: 0,
    maxWidth: '100%',
    boxSizing: 'border-box',
    // Rimossi textOverflow, overflow e whiteSpace per mostrare l'anno completo
  },

  ' fieldset': { top: 0 },
  ' button': { padding: 0 },

  // Responsive design per gli input delle date
  [theme.breakpoints.down('md')]: {
    ' input': {
      width: '100px', // Larghezza ridotta per eliminare spazio vuoto
      fontSize: '13px',
      padding: '5px 4px 6px 8px',
    },
  },

  [theme.breakpoints.down('sm')]: {
    ' input': {
      width: '95px', // Larghezza fissa per eliminare spazio vuoto su mobile
      fontSize: '12px',
      padding: '4px 3px 5px 6px',
    },
  },

  [theme.breakpoints.down('xs')]: {
    ' input': {
      width: '95px', // Larghezza fissa per eliminare spazio vuoto su mobile extra piccolo
      fontSize: '12px',
      padding: '4px 3px 5px 6px',
    },
  },
});

export const BadgeWrapper = styled(Box)(({ theme: { palette } }) => ({
  minWidth: '20px',
  height: '20px',
  backgroundColor: palette.grey[100],
  display: 'flex',
  placeContent: 'center',
  borderRadius: '50%',
}));

export const DropdownButton = styled(IconButton)(({ theme: { palette } }) => ({
  padding: 0,
  transform: 'rotate(180deg)',

  ' svg': { color: palette.common.black },
}));

export const SplitsList = styled(List)(({ theme }) => ({
  width: '280px',
  maxHeight: '395px',
  overflow: 'auto',
  padding: 0,
  display: 'flex',
  gap: '1px',
  flexDirection: 'column',

  [theme.breakpoints.down('sm')]: {
    width: 'calc(100vw - 48px)',
    maxHeight: '310px',
  },
}));

export const SplitsListItem = styled(ListItem)(({ theme }) => ({
  padding: '3px 5px',
  borderRadius: '6px',

  '&:hover': {
    backgroundColor: theme.palette.primary.light,
  },
}));

export const SplitsListItemButton = styled(ListItemButton)(() => ({
  padding: 0,
  height: '24px',

  ' p': {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '21px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  '&:hover': {
    backgroundColor: 'unset',
  },
}));

export const SplitsInputWrapper = styled(Box)(({ theme }) => ({
  cursor: 'pointer',
  padding: '5px 0',
  display: 'flex',
  gap: '5px',
  alignItems: 'center',
  justifyContent: 'space-between',
  minWidth: '120px',
  maxWidth: '100%', // Aggiunto per prevenire overflow
  boxSizing: 'border-box', // Aggiunto per calcolo corretto delle dimensioni
  overflow: 'visible', // Cambiato da 'hidden' a 'visible' per evitare tagli
  flexShrink: 0, // Aggiunto per evitare che si restringa troppo

  [theme.breakpoints.down('md')]: {
    minWidth: '100px',
  },

  [theme.breakpoints.down('sm')]: {
    width: '100%',
    padding: '8px 12px',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '4px',
    backgroundColor: theme.palette.background.paper,
  },

  [theme.breakpoints.down('xs')]: {
    padding: '6px 10px',
  },
}));

export const FilterMetricsInputWrapper = styled(Box)(({ theme }) => ({
  cursor: 'pointer',
  padding: '6.5px 5px 6.5px 10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  minWidth: '120px',
  maxWidth: '100%', // Aggiunto per prevenire overflow
  boxSizing: 'border-box', // Aggiunto per calcolo corretto delle dimensioni
  overflow: 'visible', // Aggiunto per evitare tagli
  flexShrink: 0, // Aggiunto per evitare che si restringa troppo

  [theme.breakpoints.down('sm')]: {
    width: '100%',
    padding: '8px 12px',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '4px',
    backgroundColor: theme.palette.background.paper,
  },

  [theme.breakpoints.down('xs')]: {
    padding: '6px 10px',
  },
}));

export const filterMetricsInputWrapperStyles = (
  active: boolean,
): SxProps<Theme> => ({
  borderColor: active ? palette.primary.main : undefined,

  ' svg': {
    transform: !active ? 'rotate(180deg)' : 'rotate(0deg)',
  },
});

export const HeaderTitle = styled(Typography)(() => ({
  fontSize: '18px',
  fontWeight: 600,
  lineHeigh: '23px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));
// SISTEMATO!
